import http from "./http"
import { getToken } from './auth'

const base = 'Companies'

// Tenant company profile — always the active company from the token, never by id.
export async function getCompanySelf() {
    const { data } = await http.get(`${base}/self`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// Dial code + invoice message template — readable by every role (staff send
// invoices too); editing stays on the admin-only profile endpoints.
export async function getCompanyMessaging() {
    const { data } = await http.get(`${base}/self/messaging`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// Feature toggles (materialsEnabled) — readable by every role, unlike the
// admin-only /self profile.
export async function getCompanyFeatures() {
    const { data } = await http.get(`${base}/self/features`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function updateCompanySelf(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(`${base}/self`, payload, config)
    return data
}

// Logo upload — sends the raw image file; the API stores it in the Supabase
// bucket and returns { logoUrl }.
export async function uploadCompanyLogo(file) {
    const { data } = await http.patch(`${base}/self/logo`, file, {
        headers: {
            'Content-Type': file.type,
            'Authorization': 'Bearer ' + getToken(),
        }
    })
    return data
}
